// extracted by mini-css-extract-plugin
module.exports = {"marquee":"Marquee_marquee__2pON5","marquee_content":"Marquee_marquee_content__2nLRg","scrolling":"Marquee_scrolling__xR6JM","marquee_item":"Marquee_marquee_item__1oHtt"};